// Route table. The auth guard wraps everything except /login; the layout
// shell wraps everything except /login. Settings is now a modal (no own route).

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ErrorBoundary } from "./api/errorBoundary";
import { AuthGuard } from "./auth/AuthGuard";
import { SessionGuard } from "./auth/SessionGuard";
import { Layout } from "./components/Layout";
import { Login } from "./components/Login";
import { TooltipProvider } from "./components/Tooltip";
import { DeviceProvider } from "./device/DeviceContext";
import { initI18n } from "./i18n/i18n";
import { Navigator } from "./views/Navigator";
import { PaperReview } from "./views/PaperReview";

initI18n();

export function App() {
  return (
    <ErrorBoundary>
      <DeviceProvider>
        <TooltipProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                element={
                  <AuthGuard>
                    <SessionGuard>
                      <Layout />
                    </SessionGuard>
                  </AuthGuard>
                }
              >
                <Route path="/" element={<Navigator />} />
                <Route path="/review/:paperId" element={<PaperReview />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </DeviceProvider>
    </ErrorBoundary>
  );
}
